import React, { useState } from "react";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import FormattedDate from "@egovernments/digit-ui-module-obps/src/components/TimeStamp";
import DescriptionIcon from "@mui/icons-material/Description";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";

const DocumentSectionLog = ({ logData }) => {
  console.log("logDataDocumentSection", logData);

  const detailsArray = Array.isArray(logData) ? logData : [logData];
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [createdTime, setCreatedTime] = useState(null);
  const [selectedDetails, setSelectedDetails] = useState([]);

  const openPopup = (item) => {
    setPopupData(item);
    setShowPopup(true);
    setUserDetails(item.userDetails || {});
    setCreatedTime(item.auditDetails?.createdTime || null);
    setSelectedDetails(item?.documentDetails?.documents);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };

  const printPopup = () => {
    const popupContent = document.getElementById("document-section-popup-print");
    if (!popupContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Document Section Log</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const formatDocumentType = (value) => {
    if (!value) return "-";

    return value
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const documentsWithRemarks =
    selectedDetails?.filter(
      (row) =>
        row?.documentRemarks?.trim?.() ||
        row?.documentStatus?.trim?.()
    ) || [];

  const documentsWithoutRemarks =
    selectedDetails?.filter(
      (row) =>
        !row?.documentRemarks?.trim?.() &&
        !row?.documentStatus?.trim?.()
    ) || [];
  return (
    <div>
      <h3 style={{ fontWeight: "bold", marginBottom: "10px" }}>Document Section Log</h3>
      <div style={{ overflowX: "auto", maxHeight: "300px", overflowY: "scroll" }}>
        <table
          border="1"
          cellPadding="8"
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: "600px",
            fontSize: "11px",
            position: "relative",
          }}
        >
          <thead style={{ backgroundColor: "rgba(52, 73, 94, 0.94)", position: "sticky", top: 0, zIndex: 2 }}>
            <tr style={{ fontSize: "14px", backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
              <th>User</th>
              <th>Designation</th>
              <th>Recommendation</th>
              <th>Date & Time</th>
              <th>Remarks</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {detailsArray.map((item, index) => {
              const user = item?.userDetails || {};
              const createdTime = item?.auditDetails?.createdTime || null;
              const remarks = item?.documentDetails?.developerRemarks;
              return (
                <tr key={index}>
                  <td>{user?.employeeName || user?.name || "-"}</td>
                  <td>{user?.designation || "-"}</td>
                  <td>{item?.documentDetails?.dataRecommendation || "-"}</td>
                  <td>
                    <FormattedDate timestamp={createdTime} />
                  </td>

                  <SafeHtml html={remarks || "-"} tag="td" />

                  <td>
                    <IconButton onClick={() => openPopup(item)} size="small">
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "15%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "60%",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            fontSize: "12px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>Document Section Log Info</h3>
            <div>
              <IconButton onClick={printPopup} title="Print">
                <PrintIcon />
              </IconButton>
              <IconButton onClick={closePopup} title="Close">
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div id="document-section-popup-print">
            {userDetails && (
              <div style={{ marginBottom: "10px" }}>
                <strong>User:</strong> {userDetails?.employeeName || userDetails?.name || "-"} | <strong>Designation:</strong>{" "}
                {userDetails?.designation || "-"} | <strong>Role:</strong> {userDetails?.role || "-"} |{" "}
                {/* <strong>Created At:</strong> {formatDate(createdTime)} */}
                <strong>Created At:</strong> <FormattedDate timestamp={createdTime} />
              </div>
            )}

            <React.Fragment>
              {/* Documents having remarks or status */}
              <table
                border="1"
                cellPadding="6"
                width="100%"
                style={{
                  borderCollapse: "collapse",
                  fontSize: "11px",
                  tableLayout: "fixed",
                }}
              >
                <colgroup>
                  <col style={{ width: "35%" }} />
                  <col style={{ width: "30%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "15%" }} />
                </colgroup>

                <thead style={{ backgroundColor: "#e2e8f0" }}>
                  <tr>
                    <th>Document Type</th>
                    <th>Document Remarks</th>
                    <th>Document Status</th>
                    <th style={{ textAlign: "center" }}>View</th>
                  </tr>
                </thead>

                <tbody>
                  {documentsWithRemarks.map((row, i) => (
                    <tr key={i}>
                      <td>{formatDocumentType(row?.documentType)}</td>
                      <td>{row?.documentRemarks || "-"}</td>
                      <td>{row?.documentStatus || "-"}</td>
                      <td style={{ textAlign: "center" }}>
                        {row?.fileStoreUrl && (
                          <IconButton
                            href={row.fileStoreUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                            title="Open Document"
                          >
                            <DescriptionIcon fontSize="small" />
                          </IconButton>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Documents without remarks and status */}
              {documentsWithoutRemarks.length > 0 && (
                <React.Fragment>


                  {documentsWithoutRemarks.length > 0 && (
                    <React.Fragment>


                      <table
                        border="1"
                        cellPadding="6"
                        width="100%"
                        style={{
                          borderCollapse: "collapse",
                          fontSize: "11px",
                          tableLayout: "fixed",
                        }}
                      >
                        <colgroup>
                          <col style={{ width: "85%" }} />
                          <col style={{ width: "15%" }} />
                        </colgroup>

                        <thead style={{ backgroundColor: "#e2e8f0" }}>
                          <tr>
                            <th>Document Type</th>
                            <th style={{ textAlign: "center" }}>View</th>
                          </tr>
                        </thead>

                        <tbody>
                          {documentsWithoutRemarks.map((row, i) => (
                            <tr key={i}>
                              <td>{formatDocumentType(row?.documentType)}</td>
                              <td style={{ textAlign: "center" }}>
                                {row?.fileStoreUrl && (
                                  <IconButton
                                    href={row.fileStoreUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    size="small"
                                    title="Open Document"
                                  >
                                    <DescriptionIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </React.Fragment>
                  )}
                </React.Fragment  >
              )}
            </React.Fragment>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentSectionLog;
